import getSubmoduleConfig from './get-submodule-config';
import getUpdatedUserModifiedAttributeValue from './get-updated-user-modified-attribute-value';
import convertInstructionsToActions from './convert-instructions-to-actions';

export default {
  getSubmoduleConfig,
  getUpdatedUserModifiedAttributeValue,
  convertInstructionsToActions,
};
